/**
 * api/analytics.ts —— 管理后台 · 活跃统计（2026-09-15，`14` §八）
 *
 * 🔴 **一个接口一次拿整页**：核心数字、趋势、功能表、用户表（含每人功能明细）同出一个 `asOf`。
 * ⚠ 前端**一个数都不算**：人数去重、访问切分、周界、分桶全在服务端（红线 4）。
 */
import { get, type ReqOptions } from './client.js';
import type { AnalyticsOverview, AnalyticsQuery } from '@shared-types';

export const overview = (q: AnalyticsQuery, opts?: ReqOptions): Promise<AnalyticsOverview> => {
  const p = new URLSearchParams({ preset: q.preset, grain: q.grain ?? 'day' });
  if (q.preset === 'custom') {
    p.set('from', q.from ?? '');
    p.set('to', q.to ?? '');
  }
  return get<AnalyticsOverview>(`/api/analytics/overview?${p.toString()}`, opts);
};
